export default "__VITE_ASSET__CFTT$1KN__"